import React, { useEffect, useRef } from 'react';
import './Home.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logoImg from '../../images/Doumicomgroup4.png';
import Img from "../../images/Doumicomgroup2.png";
import Img2 from "../../images/Doumicom11PowerPackObamaLocation1.jpg";
import Img3 from "../../images/Doumicomgroup5.png";
import Img4 from "../../images/IMG20150502WA0001.jpg";

const Home = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const animatedElements = containerRef.current.querySelectorAll(
      '.reveal-right, .reveal-left'
    );

    const observerOptions = {
      root: null,
      threshold: 0.15, 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="home" ref={containerRef}>
      <div className="brand-container reveal-right">
        <h1 className="brand-title-main">DOUMICOM</h1>
        
        <div className="brand-sub-row">
          <div className="brand-image-wrapper">
            <img
              src={logoImg}
              alt="Doumicom Group Graphic"
              className="home-logo"
            />
          </div>
          <h2 className="brand-title-sub">GROUP</h2>
        </div>
      </div>
      
      <div className='home-img-wrapper reveal-left'>
        <img src={Img} className='home-img' alt='Doumicom Img'/>
      </div>
      
      <div className='home-intro-section reveal-right'>
        <h3 className='home-header'>Doumicom International Limited</h3>
        <p className='home-intro-paragraph'>
          Doumicom International Limited is a leading Engineering, Procurement, Construction Management (EPCM) and Project Management Consultancy 
          (PMC) company, delivering integrated engineering, procurement, construction, and project management solutions across the energy and 
          industrial sectors. From concept development to project completion, we provide innovative, reliable, and cost-effective solutions tailored 
          to our clients' needs.
        </p>
      </div>
      <div className='home-intro-section reveal-right'>
        <h3 className='home-header'>Doumicom Oil Services Limited</h3>
        <p className='home-intro-paragraph'>
          Doumicom Oil Services Limited is a specialized oil and gas services company supporting the upstream, midstream, and downstream sectors. 
          We deliver advanced industrial solutions, including pumps, compressors, valves, pressure safety valves (PSVs), pressure vessels, process 
          skids, fire & gas systems, rotating equipment, and wellheads, backed by technical expertise and strategic OEM partnerships to ensure safe, 
          efficient, and reliable operations.
        </p>
      </div>

      <div className='home-img-wrapper1 reveal-left'>
        <img src={Img2} className='home-img1' alt='Doumicom Img2'/>
      </div>

      <div className='home-about reveal-right'>
        <div className="home-about-left">
          <h3 className='home-header1'>ABOUT US</h3>
          <div className='about-logo-wrapper'>
            <img
              src={Img3}
              alt="Doumicom Group Graphic"
              className="about-sub-logo"
            />
          </div>
          
          <p className='home-about-paragraph'>
            <strong>DOUMICOM Group</strong> is a leading EPCM and PMC company delivering integrated engineering, construction, project management, and specialized oil & gas solutions across Nigeria. Backed by global partnerships and strong local expertise, we provide reliable, end-to-end solutions that drive efficiency, innovation, and sustainable growth across the energy and industrial sectors.
          </p>
        </div>
        
        <div className='right-img'>
          <img src={Img4} className='home-logo1' alt="About us secondary graphic" />
        </div>
      </div>

      <div className="scroll-to-top-container">
        <button onClick={scrollToTop} className="scroll-to-top-btn" aria-label="Scroll to top">
          <div className="block-arrow-up"></div>
        </button>
      </div>
    </div>
  );
}

export default Home;